<template>
    <div class="quill-view" v-bind="$attrs" v-html="displayValue"></div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
    name: "QuillView",
    props: {
        value: {
            type: String,
            default: "",
        },
        trusted: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        displayValue(): string {
            if (!this.value || this.value.trim() === "") {
                return "";
            }
            
            const trimmed = this.value.trim();
            
            // Sanitize HTML first before normalization (unless trusted)
            let processed = this.trusted ? trimmed : this.$sanitizeHtml(trimmed).trim();
            
            // Replace single non-consecutive &nbsp; with regular spaces
            // First, protect consecutive &nbsp; (2 or more) with a placeholder
            const placeholder = "__NBSP_PLACEHOLDER__";
            processed = processed.replace(/(&nbsp;){2,}/g, (match) => {
                return match.replace(/&nbsp;/g, placeholder);
            });
            
            // Replace remaining single &nbsp; with spaces
            processed = processed.replace(/&nbsp;/g, " ");
            
            // Restore consecutive &nbsp;
            processed = processed.replace(new RegExp(placeholder, "g"), "&nbsp;");

            processed = processed.trim();
            
            // Normalize empty paragraphs to empty string
            if (processed === "<p></p>" || processed === "<p><br></p>" || processed === "") {
                return "";
            }
            
            return processed;
        },
    },
});
</script>

<style>

.theme--light .quill-view p {
    color: black;
}

/* RTL languages */
html[lang="he"] .quill-view,
html[lang="ar"] .quill-view {
    text-align: right;
}

/* Ensure images respect max-width */
.quill-view img {
    max-width: 100%;
    height: auto;
}

/* Style links */
.quill-view a {
    color: inherit;
    text-decoration: underline;
}

.theme--dark .quill-view a {
    color: #90caf9;
}
</style>
